import { useDispatch, useSelector } from 'react-redux';

import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { AppDispatch } from '@/Redux/ConfigureStore';
import {
  documentPrintModalActions,
  documentPrintModalAsyncActions,
  DocumentPrintStep,
} from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { useEffect } from 'react';
import { WINDOW_MODAL_TYPE } from '@/ModalWindows/services';
import { orderTableRowUtils } from '@/Types/OrderTableRowUtils';

export function useDocumentPrintModalOptions() {
  const dispatch: AppDispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const selectedSales = useSelector(salesPageSelectors.selectedSales);
  const currentStep = useSelector(documentPrintModalSelectors.currentStep);
  const documentType = useSelector(documentPrintModalSelectors.documentType);

  useEffect(() => {
    const documentPrintType = WINDOW_MODAL_TYPE[location.pathname];
    dispatch(documentPrintModalAsyncActions.getDocumentTemplates(documentPrintType));
  }, []);

  useEffect(() => {
    const documentNumbers = selectedSales.map((order) => ({
      numbers: orderTableRowUtils.getDocumentNumbersByType(documentType, order),
      orderId: order.id,
    }));

    dispatch(documentPrintModalActions.setSelectedTypeNumbers(documentNumbers));
  }, [documentType]);

  useEffect(() => {
    if (documentType && selectedSale) {
      const documentNumbers = orderTableRowUtils.getDocumentNumbersByType(documentType, selectedSale);

      if (documentNumbers.length == 0) {
        dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.CreateDocument));
      } else if (documentNumbers.length == 1) {
        dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.SingleDocumentPrint));
      } else {
        dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.SelectDocumentNumber));
      }
    } else {
      dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.SelectTemplate));
    }

    return () => {
      dispatch(documentPrintModalActions.resetState());
    };
  }, []);

  return {
    currentStep,
  };
}
